import { render, staticRenderFns } from "./InviteFriendsGiftCode.vue?vue&type=template&id=60a38914&scoped=true&"
import script from "./InviteFriendsGiftCode.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsGiftCode.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriendsGiftCode.vue?vue&type=style&index=0&id=60a38914&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a38914",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VSelect,VTooltip})
